module.exports = __webpack_public_path__ + "img/259.81216d48.png";